import React, { useEffect, useRef, useState } from "react";
import { Play, Pause, Mic } from "lucide-react";

const audioUrl = (id, part) => `${process.env.REACT_APP_BACKEND_URL}/api/cheer-audio/${id}?part=${part}&auth=${localStorage.getItem("tycc_token")}`;
const fmt = (s) => (Number.isFinite(s) ? `0:${String(Math.floor(s)).padStart(2, "0")}` : "");

// Play button for a cheer's voice note, or the child's voice reply (part="reply"); streams from the backend with the JWT.
const VoicePlayer = ({ cheer, author, part = "cheer", tone = "pink", autoPlay = false }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [pct, setPct] = useState(0);
  const [dur, setDur] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!autoPlay || !ref.current) return;
    ref.current.play().then(() => setPlaying(true)).catch(() => {}); // autoplay may be blocked without a gesture - the cheer is still highlighted
  }, [autoPlay]);
  const voice = part === "reply" ? cheer.reply?.voice : cheer.voice;
  if (!voice) return null;
  const c = tone === "green" ? { bg: "bg-[#e8f8ef]", border: "border-[#63c79a]", btn: "bg-[#2e8b57] hover:bg-[#25714a]", bar: "bg-[#2e8b57]", text: "text-[#0d4d33]" } : { bg: "bg-[#fff0f5]", border: "border-[#f9a8c9]", btn: "bg-[#e5356f] hover:bg-[#c92a5e]", bar: "bg-[#e5356f]", text: "text-[#7a1f45]" };
  const tid = part === "reply" ? `reply-voice-${cheer.id}` : `cheer-voice-${cheer.id}`;
  const playTid = part === "reply" ? `reply-voice-play-${cheer.id}` : `cheer-voice-play-${cheer.id}`;

  const toggle = () => {
    const a = ref.current;
    if (playing) { a.pause(); setPlaying(false); return; }
    a.play().then(() => setPlaying(true)).catch(() => setErr(true));
  };

  return (
    <div className={`mt-2 inline-flex items-center gap-2 rounded-full ${c.bg} border ${c.border} pl-1 pr-3 py-1 max-w-full ${autoPlay ? "ring-2 ring-[#e5356f] ring-offset-1" : ""}`} data-testid={tid}>
      <audio ref={ref} src={audioUrl(cheer.id, part)} preload="metadata" onLoadedMetadata={(e) => setDur(e.target.duration)} onTimeUpdate={(e) => setPct(e.target.duration ? (e.target.currentTime / e.target.duration) * 100 : 0)} onEnded={() => { setPlaying(false); setPct(0); }} onError={() => setErr(true)} />
      <button type="button" onClick={toggle} disabled={err} className={`w-8 h-8 rounded-full ${c.btn} text-white flex items-center justify-center disabled:opacity-50 flex-shrink-0`} aria-label={playing ? "Pause voice note" : `Play voice note from ${author}`} data-testid={playTid}>{playing ? <Pause size={13} /> : <Play size={13} className="ml-0.5" />}</button>
      <span className="w-20 h-1.5 rounded-full bg-white overflow-hidden"><span className={`block h-full ${c.bar} transition-[width] duration-150`} style={{ width: `${pct}%` }} /></span>
      <span className={`text-[11px] font-bold ${c.text} inline-flex items-center gap-1 whitespace-nowrap`}><Mic size={11} /> {err ? "Unavailable" : dur ? fmt(dur) : part === "reply" ? `${author} says` : "Voice note"}</span>
    </div>
  );
};

export default VoicePlayer;
